import InputGroup from "./InputGroup";
import PasswordRequirements from "./PasswordRequirements";

function LoginForm({ username, setUsername, password, setPassword, onForgotPassword }) {
  return (
    <>
      <InputGroup
        label="Username or Email"
        name="username"
        id="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <div className="input-group">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="forgot">
          <a rel="noopener noreferrer" href="#" onClick={(e) => {
            e.preventDefault();
            onForgotPassword();
          }}>
            Forgot Password?
          </a>
        </div>
      </div>
    </>
  );
}

export default LoginForm;
